export default "__VITE_ASSET__BJGyg6Sl__"